import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-charging',
  templateUrl: './custom-charging.component.html',
  styleUrls: ['./custom-charging.component.css']
})
export class CustomChargingComponent {

  @Input() label?: string;
  @Input() isLoading: boolean = false;

}
